import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

export default function LoginRequiredModal({ isOpen, toggle }) {
    const history = useHistory();

    const handleLoginRedirect = () => {
        toggle(); // cerrar modal
        history.push('/login'); // redirigir al login
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Iniciar sesión requerido</ModalHeader>
            <ModalBody>
                Debes iniciar sesión para realizar esta acción.
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleLoginRedirect}>Iniciar sesión</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
}